/* eslint-disable react-refresh/only-export-components */
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils/cn';

const paragraphVariants = cva('text-base', {
  variants: {
    size: {
      xs: 'text-xs',
      sm: 'text-xs md:text-sm',
      base: 'text-sm md:text-base',
      lg: 'text-base md:text-lg',
      xl: 'text-lg md:text-xl',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
  },
  defaultVariants: {
    size: 'base',
    align: 'left',
  },
});

export interface ParagraphProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof paragraphVariants> {
  as?: React.ElementType;
  color?: string;
}

function Paragraph({
  as,
  className,
  size = 'base',
  align = 'left',
  style,
  children,
  color,
  ...rest
}: ParagraphProps) {
  const Tag = as || 'p';
  const mergedStyle = {
    ...style,
    ...(color && { color }),
  };

  return (
    <Tag
      className={cn(paragraphVariants({ size, align }), className)}
      style={mergedStyle}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export { Paragraph, paragraphVariants };
